import React,{useState,useEffect} from 'react';
import {Link} from 'react-router-dom';
import {motion,AnimatePresence} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import SEO from '../common/SEO';
import GoogleMaps from '../components/GoogleMaps';
import * as FiIcons from 'react-icons/fi';

const {FiTool,FiHome,FiShield,FiLayers,FiPaintBucket,FiGrid,FiUser,FiBookOpen,FiChevronRight,FiSearch,FiDollarSign,FiZap,FiWind,FiCheckCircle,FiHelpCircle,FiMapPin,FiCloud,FiVolume2,FiThermometer,FiPieChart,FiMicOff,FiTrendingUp,FiTruck,FiFileText}=FiIcons;

function Home() {
  const [activeVideo,setActiveVideo]=useState(null);

  useEffect(()=> {
    if (!document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
      const script=document.createElement('script');
      script.src='https://elfsightcdn.com/platform.js';
      script.async=true;
      script.defer=true;
      document.head.appendChild(script);
    }
  },[]);

  const homeSchema={
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "name": "MK-AUSBAU",
    "image": "https://ausbau.nrw/logo-icon.svg",
    "description": "Ihr Fachbetrieb für Innenausbau,Trockenbau und Sanierung in Heinsberg und Umgebung. Qualität und Präzision seit 2016.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Am Diebsweg 17",
      "addressLocality": "Heinsberg",
      "postalCode": "52525",
      "addressCountry": "DE"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 51.040953,
      "longitude": 6.1716098
    },
    "url": "https://ausbau.nrw",
    "telephone": "+4924528607038",
    "priceRange": "$$",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
        "opens": "07:00",
        "closes": "17:00"
      }
    ],
    "sameAs": [
      "https://www.instagram.com/mk_ausbau"
    ]
  };

  const services=[
    {icon: FiLayers,title: 'Trocken- und Akustikbau',description: 'Professionelle Trockenbauarbeiten und Akustiklösungen für optimale Raumgestaltung.',link: '/trockenbau'},
    {icon: FiShield,title: 'Dämmtechnik',description: 'Hochwertige Dämmarbeiten für Energieeffizienz und Wohnkomfort.',link: '/daemmtechnik'},
    {icon: FiHome,title: 'Innentürmontage',description: 'Fachgerechte Montage von Innentüren aller Art mit präziser Passgenauigkeit.',link: '/innentuer'},
    {icon: FiGrid,title: 'Bodenbelagsarbeiten',description: 'Verlegung verschiedener Bodenbeläge von Laminat bis Fliesen.',link: '/bodenbelag'},
    {icon: FiPaintBucket,title: 'Maler- und Beschichtungsarbeiten',description: 'Professionelle Malerarbeiten und Oberflächenbeschichtungen.',link: '/maler'},
    {icon: FiTool,title: 'PU-Designböden (3D Optik)',description: 'Moderne Designböden mit beeindruckender 3D-Optik für einzigartige Raumgestaltung.',link: '/designboden'}
  ];

  // Alle Blogposts - NEUESTER BEITRAG OBEN
  const topics=[
    {
      title: "Förderprogramme NRW 2026: Über 50 Förderungen für Hausbesitzer",
      description: "Bis zu 70% Zuschuss! 💰 Der komplette Guide für Sanierung,Renovierung & Modernisierung. NRW.BANK,KfW & BAFA im Überblick.",
      link: "/blog/foerderprogramme-hausbesitzer-nrw-2026",
      icon: FiDollarSign,
      category: "Finanzen & Förderung"
    },
    {
      title: "Spachtelarbeiten im Trockenbau – Fehler vermeiden | Experten-Check",
      description: "Risse an Deckenanschlüssen? Abhebende Farbe? 🛠️ Unsere Baustellen-Checkliste für Heinsberg deckt die häufigsten Fehler beim Spachteln auf.",
      link: "/blog/spachtelarbeiten-trockenbau-fehler-vermeiden",
      icon: FiTool,
      category: "Innenausbau & Praxis"
    },
    {
      title: "Schafwolle Dämmung – Vorteile & Nachteile | MK-AUSBAU",
      description: "Nachhaltig & Effizient: Warum Schafwolle der ideale Dämmstoff für NRW ist. Alles zu Kosten,Brandschutz und Raumklima.",
      link: "/blog/schafwolle-daemmung-vorteile-nachteile",
      icon: FiCloud,
      category: "Ökologische Baustoffe",
      video: "https://canv.wasacon.com/mk-ausbau/_assets/video/3f860b43bdc354a59813a3e10effe477.mp4"
    },
    {
      title: "Trockenbau-Anfrage richtig stellen: Die Checkliste für schnelle Angebote",
      description: "So bekommen Sie Angebote ohne Rückfragen. Mit kopierbarer Muster-Vorlage für Ihre Anfrage!",
      link: "/blog/trockenbau-anfrage-richtig-stellen",
      icon: FiFileText,
      category: "Ratgeber & Checklisten",
    },
    {
      title: "Kellerdeckendämmung – sinnvoll oder überschätzt?",
      description: "Wann sie wirklich lohnt und wann andere Maßnahmen mehr bringen. Mit interaktivem Amortisations-Rechner!",
      link: "/blog/kellerdeckendaemmung",
      icon: FiTrendingUp,
      category: "Energie & Dämmung",
    },
    {
      title: "Kerndämmung: Schnelle Wärmedämmung ohne Baustelle",
      description: "Hohlwanddämmung für zweischaliges Mauerwerk. Ideal für Häuser im Kreis Heinsberg & NRW. Kosteneffizient & schnell.",
      link: "/blog/kerndaemmung",
      icon: FiShield,
      category: "Energie & Dämmung",
    },
    {
      title: "Unverbindliches Angebot für Trockenbau,Dämmung & Innenausbau",
      description: "Von Strohdämmung bis Glaswolle – regional stark in NRW. Ein seriöses Angebot beginnt immer mit einer realistischen Einschätzung.",
      link: "/blog/unverbindliches-angebot-innenausbau",
      icon: FiFileText,
      category: "Angebot & Service",
    },
    {
      title: "Gebäude mit eingeblasenem Stroh: Vom Feld zur Fertigung",
      description: "Warum diese natürliche Dämmung für den Mainstream bereit ist – auch in NRW. Kreislaufwirtschaft & CO2-Speicherung.",
      link: "/blog/stroh-einblasdaemmung",
      icon: FiCloud,
      category: "Ökologische Baustoffe",
    },
    {
      title: "Energetische Sanierung im Kreis Heinsberg: Von Effizienzklasse H auf A ohne 200.000 €",
      description: "Wie Hausbesitzer ihr Einfamilienhaus kosteneffizient sanieren. Hohlwanddämmung,Heizungsoptimierung & Co. im Praxis-Check.",
      link: "/blog/energetische-sanierung-heinsberg",
      icon: FiTrendingUp,
      category: "Sanierung & Effizienz",
    },
    {
      title: "Dachdämmung richtig planen: So sparst du massiv Heizkosten und vermeidest teure Fehler",
      description: "Dach dämmen oder Geschossdecke? 🏠 Anleitung für Steildächer,Einblasdämmung & Hitzeschutz. Vermeide diesen teuren 30%-Fehler!",
      link: "/blog/dachdaemmung-richtig-planen",
      icon: FiThermometer,
      category: "Energie & Dämmung",
    },
    {
      title: "Schallschutz im Trockenbau: Wie Sie Lärm effektiv aus Ihren Räumen fernhalten",
      description: "Ruhe im Haus! 🤫 Erfahren Sie,wie das Masse-Feder-Masse-Prinzip funktioniert und wie Sie Wände und Decken effektiv entkoppeln.",
      link: "/blog/schallschutz-trockenbau",
      icon: FiMicOff,
      category: "Bauphysik & Akustik",
    },
    {
      title: "Mieten oder Kaufen in Deutschland heute: Was Daten und Trends wirklich nahelegen",
      description: "Lohnt sich der Immobilienkauf 2026 noch? Ein datenbasierter Vergleich zwischen Eigenheim und Mieten + ETF-Sparplan unter Berücksichtigung der Zinswende.",
      link: "/blog/mieten-oder-kaufen",
      icon: FiHome,
      category: "Finanzen & Markt",
    },
    {
      title: "Was müssen Sie beim Trockenbau beachten? – Der komplette Praxisleitfaden",
      description: "Von Materialwahl über Schallschutz bis zu Kosten: Ein umfassender Guide für Bauherren und Profis für erfolgreiche Trockenbauprojekte.",
      link: "/blog/trockenbau-leitfaden",
      icon: FiLayers,
      category: "Innenausbau & Praxis",
      video: "https://canv.wasacon.com/mk-ausbau/_assets/video/0dd191b3fbc4073de59eaa3e7e7af053.mp4"
    },
    {
      title: "Bau Kosten richtig abschätzen – Praxisleitfaden für Planer,Eigentümer und Investoren",
      description: "Wie Sie Baukosten fundiert kalkulieren,Risiken minimieren und Budgets einhalten. Ein Leitfaden für Planer und Investoren mit Checkliste.",
      link: "/blog/baukosten-abschaetzen",
      icon: FiPieChart,
      category: "Kosten & Planung",
      video: "https://canv.wasacon.com/mk-ausbau/_assets/video/82ed14dcdc0014ad2da14a78871f0cc0.mp4"
    },
    {
      title: "Wie Sie mit moderner Dämmtechnik Energie sparen und den Wohnkomfort steigern",
      description: "Ein umfassender Ratgeber zu Materialien,Förderungen und der richtigen Strategie für Ihre Sanierung. Sparen Sie bis zu 70% Energie.",
      link: "/blog/moderne-daemmtechnik",
      icon: FiThermometer,
      category: "Energie & Dämmung",
      video: "https://canv.wasacon.com/mk-ausbau/_assets/video/a7fc41cae4aaa33c323e07fa2ec82fed.mp4"
    },
    {
      title: "Schallschutz bei Holzbalkendecken: Warum Mineralwolle allein ein Fehler ist",
      description: "Warum das Entfernen alter Schüttungen und der reine Einsatz von Mineralwolle den Schallschutz massiv verschlechtern kann – und wie man es richtig macht.",
      link: "/blog/schallschutz-holzbalkendecke",
      icon: FiVolume2,
      category: "Bauphysik & Akustik",
      video: "https://canv.wasacon.com/mk-ausbau/_assets/video/aa52708dd16e259ad47564a0dbe3e256.mp4"
    },
    {
      title: "Kauft das bitte nicht – bevor ihr DAS getan habt!",
      description: "Professionelle Ankaufsprüfung bei sanierungsbedürftigen Mehrfamilienhäusern. Warum 'hässliche Entlein' oft die besten Deals sind.",
      link: "/blog/ankaufspruefung-mehrfamilienhaus",
      icon: FiSearch,
      category: "Ankaufsprüfung",
      video: "https://canv.wasacon.com/mk-ausbau/_assets/video/6d93031f137eb76a3117f4e1ac71b858.mp4"
    },
    {
      title: 'Günstiger bauen statt über 3.000 €/m²: Low-Hanging-Fruits für wirtschaftliche Zinshäuser',
      description: 'Wo liegen die Hebel,um Baukosten massiv zu reduzieren? Ein Ratgeber zu TGA-Optimierung,Normabweichungen und smarten Planungslösungen.',
      link: '/blog/wirtschaftliches-bauen',
      icon: FiDollarSign,
      category: 'Wirtschaftlichkeit',
      video: "https://canv.wasacon.com/mk-ausbau/_assets/video/a6b6405a0560277e8cb39fc6c9b0ce68.mp4"
    },
    {
      title: 'Zweifach,dreifach oder vierfach verglaste Fenster 2026: Was lohnt sich wirklich?',
      description: 'Entscheidungshilfe für den Fenstertausch: Wann sich Dreifachverglasung amortisiert und warum Vierfachverglasung oft Overkill ist.',
      link: '/blog/fensterverglasung-2026',
      icon: FiZap,
      category: 'Energieeffizienz',
      video: "https://canv.wasacon.com/mk-ausbau/_assets/video/188ba5d0976327788737711a7d3d8a74.mp4"
    },
    {
      title: 'Dampfbremse in der Holzdecke?',
      description: 'Warum eine Dampfbremse bei Holzkonstruktionen überlebenswichtig für die Bausubstanz ist und was Sie beachten müssen.',
      link: '/blog/dampfbremse-holzdecke',
      icon: FiWind,
      category: 'Dämmtechnik & Bauphysik',
      video: "https://canv.wasacon.com/mk-ausbau/_assets/video/ef31a4f633cac51535705f1c0f35c22e.mp4"
    }
  ];

  const faqs=[
    {
      question: "In welchem Umkreis ist MK-AUSBAU tätig?",
      answer: "Wir sind primär im Kreis Heinsberg,Geilenkirchen,Erkelenz und Mönchengladbach tätig,übernehmen aber auch größere Projekte in ganz NRW."
    },
    {
      question: "Bieten Sie alles aus einer Hand an?",
      answer: "Ja,wir koordinieren als Generalunternehmer für Innenausbau alle Gewerke wie Trockenbau,Boden,Maler und Montage,um Ihnen eine stressfreie Sanierung zu garantieren."
    },
    {
      question: "Wie schnell erhalte ich ein Angebot?",
      answer: "Nach einer Besichtigung vor Ort erhalten Sie in der Regel innerhalb von 3-5 Werktagen ein detailliertes und transparentes Festpreisangebot."
    }
  ];

  return (
    <div>
      <SEO 
        title="Innenausbau & Sanierung Heinsberg | MK-AUSBAU" 
        description="Ihr Experte für Innenausbau,Trockenbau & Sanierung in Heinsberg. ✅ Alles aus einer Hand ✅ Fachgerecht & Zuverlässig. Jetzt Angebot anfordern!" 
        keywords="Innenausbau Heinsberg,Sanierung,Trockenbau,Renovierung,Handwerker Heinsberg" 
        schema={homeSchema} 
        canonical="/" 
      />

      {/* Elfsight Slider */}
      <section className="w-full bg-white overflow-hidden">
        <div className="elfsight-app-b2cac12c-ff40-4e26-a7f1-e1c86bbff86c" data-elfsight-app-lazy></div>
      </section>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-mk-teal-500 to-mk-teal-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            initial={{opacity: 0,y: 20}} 
            animate={{opacity: 1,y: 0}} 
            transition={{duration: 0.8}} 
            className="text-center"
          >
            <div className="flex justify-center mb-8">
              <img src="https://wasacon.de/logo_mk_ausbau.png" alt="MK-AUSBAU Logo" className="h-24 w-auto filter brightness-0 invert" />
            </div>
            <h1 className="text-4xl md:text-6xl font-bold mb-6">MK-AUSBAU Heinsberg</h1>
            <p className="text-xl md:text-2xl mb-8 text-mk-teal-100">Ihr Partner für Innenausbau & Sanierung</p>
            <p className="text-lg md:text-xl max-w-3xl mx-auto mb-10 text-mk-teal-200 leading-relaxed">
              Wir verwandeln Wohnräume in Heinsberg und Umgebung. Zuverlässig,präzise und mit höchstem Qualitätsanspruch realisieren wir Ihr Bauvorhaben – vom Trockenbau bis zum Designboden.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link to="/kontakt" className="inline-block bg-mk-red-700 hover:bg-mk-red-800 text-white px-8 py-4 rounded-sm text-lg font-semibold transition-colors shadow-lg">
                Kostenlose Beratung anfordern
              </Link>
              <a href="https://kundenportal.ausbau.nrw/authentication/login" target="_blank" rel="noopener noreferrer" className="inline-flex items-center space-x-3 bg-white hover:bg-gray-50 text-mk-teal-700 px-8 py-4 rounded-sm text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105" >
                <SafeIcon icon={FiUser} className="w-5 h-5" />
                <span>Kundenlogin</span>
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* AI-Optimierter "Über Uns" Kurztext für Local SEO */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-mk-teal-600 font-bold tracking-wider uppercase text-sm">Ihr Fachbetrieb vor Ort</span>
          <h2 className="text-3xl font-bold text-gray-900 mt-2 mb-6">Was macht MK-AUSBAU?</h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            <strong>MK-AUSBAU</strong> ist ein spezialisierter Handwerksbetrieb mit Sitz in <strong>Heinsberg</strong>,der sich auf hochwertigen <strong>Innenausbau</strong> und ganzheitliche <strong>Sanierungskonzepte</strong> fokussiert. Wir unterstützen Bauherren und Eigentümer bei der Modernisierung von Immobilien durch professionellen Trockenbau,effiziente Dämmtechnik und moderne Bodenbeläge. Unser Ziel ist es,nachhaltige Werte zu schaffen und Wohnkomfort durch fachgerechte Ausführung zu maximieren.
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            initial={{opacity: 0,y: 20}} 
            whileInView={{opacity: 1,y: 0}} 
            transition={{duration: 0.6}} 
            viewport={{once: true}}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Unsere Dienstleistungen</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Maßgeschneiderte Lösungen für Ihr Zuhause. Wir bieten ein umfassendes Leistungsspektrum für Neubau und Altbausanierung.
            </p>
          </motion.div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service,index)=> (
              <motion.div 
                key={service.title}
                initial={{opacity: 0,y: 20}}
                whileInView={{opacity: 1,y: 0}}
                transition={{duration: 0.6,delay: index * 0.1}}
                viewport={{once: true}}
                className="group"
              >
                <Link to={service.link} className="block h-full bg-white p-6 rounded-xl hover:shadow-lg transition-all duration-300 group-hover:scale-105 border border-gray-100 hover:border-mk-teal-100">
                  <div className="w-12 h-12 bg-mk-teal-500 rounded-lg flex items-center justify-center mb-4 group-hover:bg-mk-teal-600 transition-colors">
                    <SafeIcon icon={service.icon} className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-mk-teal-700 transition-colors">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                </Link>
              </motion.div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <Link to="/services" className="inline-block bg-mk-teal-500 hover:bg-mk-teal-600 text-white px-8 py-3 rounded-sm font-semibold transition-colors shadow-md">
              Alle Dienstleistungen ansehen
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            initial={{opacity: 0,y: 20}} 
            whileInView={{opacity: 1,y: 0}} 
            transition={{duration: 0.6}} 
            viewport={{once: true}}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Warum MK-AUSBAU?</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Qualität,die man sieht und spürt.</p>
          </motion.div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {icon: FiCheckCircle,title: 'Erfahrung & Qualität',description: 'Jahrelange Erfahrung und höchste Qualitätsstandards in allen Bereichen des Innenausbaus.'},
              {icon: FiCheckCircle,title: 'Zuverlässigkeit',description: 'Termingerechte Ausführung und verlässliche Partnerschaft von der Planung bis zur Fertigstellung.'},
              {icon: FiCheckCircle,title: 'Faire Preise',description: 'Transparente Kostenvoranschläge und faire Preise für erstklassige Handwerksleistungen.'}
            ].map((feature,index)=> (
              <motion.div 
                key={feature.title}
                initial={{opacity: 0,y: 20}}
                whileInView={{opacity: 1,y: 0}}
                transition={{duration: 0.6,delay: index * 0.2}}
                viewport={{once: true}}
                className="text-center p-6 bg-gray-50 rounded-xl"
              >
                <SafeIcon icon={feature.icon} className="w-10 h-10 text-mk-teal-500 mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Topics Section - MIT VIDEO BACKGROUND */}
      <section className="py-20 relative overflow-hidden border-t border-gray-100 transition-colors duration-500">
        
        {/* Background Video Layer */}
        <AnimatePresence>
          {activeVideo && (
            <motion.div 
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              exit={{opacity: 0}}
              transition={{duration: 0.5}}
              className="absolute inset-0 z-0"
            >
              <video 
                src={activeVideo} 
                autoPlay 
                loop 
                muted 
                playsInline 
                className="w-full h-full object-cover"
              />
              {/* Overlay für Lesbarkeit */}
              <div className="absolute inset-0 bg-white/85 backdrop-blur-[2px]"></div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Default Background Layer - Falls kein Video läuft */}
        <div className="absolute inset-0 bg-white -z-10"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <motion.div 
            initial={{opacity: 0,y: 20}} 
            whileInView={{opacity: 1,y: 0}} 
            transition={{duration: 0.6}} 
            viewport={{once: true}}
            className="text-center mb-16"
          >
            <div className="inline-flex items-center justify-center p-2 bg-mk-teal-100 rounded-lg mb-4 text-mk-teal-600">
              <SafeIcon icon={FiBookOpen} className="w-6 h-6" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Ratgeber & Fachwissen</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Wir teilen unsere Expertise. Entdecken Sie wertvolle Informationen rund um Sanierung und Innenausbau.
            </p>
          </motion.div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {topics.map((topic,index)=> (
              <motion.div 
                key={topic.link}
                initial={{opacity: 0,y: 20}}
                whileInView={{opacity: 1,y: 0}}
                transition={{delay: index * 0.1}}
                viewport={{once: true}}
                onMouseEnter={()=> topic.video && setActiveVideo(topic.video)}
                onMouseLeave={()=> setActiveVideo(null)}
              >
                <Link to={topic.link} className="group block h-full bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-500 overflow-hidden border border-gray-100 flex flex-col">
                  <div className="p-8 flex-grow">
                    <div className="flex items-center justify-between mb-4">
                      <span className="text-[10px] font-bold text-mk-teal-600 uppercase tracking-widest bg-mk-teal-50 px-3 py-1 rounded-full">
                        {topic.category}
                      </span>
                      <SafeIcon icon={topic.icon} className="w-5 h-5 text-gray-300 group-hover:text-mk-teal-500 transition-colors" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-mk-teal-600 transition-colors leading-tight text-left">
                      {topic.title}
                    </h3>
                    <p className="text-gray-500 text-sm leading-relaxed text-left line-clamp-3">
                      {topic.description}
                    </p>
                  </div>
                  <div className="px-8 py-5 bg-gray-50 border-t border-gray-100 flex items-center text-mk-red-700 text-sm font-bold group-hover:bg-mk-teal-50 transition-colors">
                    <span>Artikel lesen</span>
                    <SafeIcon icon={FiChevronRight} className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section - Neu für SEO & Voice Search */}
      <section className="py-16 bg-mk-teal-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <SafeIcon icon={FiHelpCircle} className="w-10 h-10 text-mk-teal-600 mx-auto mb-4" />
            <h2 className="text-3xl font-bold text-gray-900">Häufig gestellte Fragen</h2>
            <p className="text-gray-600 mt-2">Antworten auf die wichtigsten Fragen zu Ihrem Bauprojekt.</p>
          </div>
          
          <div className="space-y-4">
            {faqs.map((faq,index)=> (
              <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-mk-teal-100">
                <h3 className="font-bold text-gray-900 mb-2">{faq.question}</h3>
                <p className="text-gray-700">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reviews & Social & Maps */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-20">
          <div>
            <h2 className="text-3xl font-bold text-center mb-8">Kundenbewertungen</h2>
            <div className="elfsight-app-8dc56305-5035-4ed3-995a-6aeae3dc8497" data-elfsight-app-lazy></div>
          </div>
          <div>
            <h2 className="text-3xl font-bold text-center mb-8">Instagram</h2>
            <div className="elfsight-app-b356c868-1856-4049-9659-ef5af0fcbdab" data-elfsight-app-lazy></div>
          </div>
        </div>
      </section>

      <GoogleMaps />
    </div>
  );
}

export default Home;